export const UPGRADE_BANNER_BACKGROUND =
  'https://static.rfstat.com/renderforest/images/website_maker_images/upgrade_banner_background.svg'
export const GRADIENT_CHECK =
  'https://static.rfstat.com/renderforest/images/website_maker_images/gradient_check_icon.svg'
